import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-revoke-prompt',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule],
  templateUrl: './revoke-prompt.component.html',
  styleUrl: './revoke-prompt.component.scss'
})
export class RevokePromptComponent {

  revokeReason: string = '';  
  formSubmitted: boolean = false;
  loggedUserId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RevokePromptComponent>,
  ) {
    this.loggedUserId = localStorage.getItem("user_id")
  }

  cancelPrompt() {
    this.formSubmitted = false;
    this.dialogRef.close();
  }

  revokePrompt(form:any) {
    this.formSubmitted = true;
    
    
    if (form.valid && this.revokeReason !== '') {
      const postData = {
        status: "REVOKED",
        revoke_reason: this.revokeReason,
        curator_user_id: this.loggedUserId,
        prompt_id: this?.data?.prompt_id
    }
      this.dialogRef.close(postData);
    } else {
      form.controls?.comments?.markAsTouched();
      // this.dialogRef.close();
    }
  }

}
